import { render, staticRenderFns } from "./SelectDefault.vue?vue&type=template&id=b5d425a0&scoped=true"
import script from "./SelectDefault.vue?vue&type=script&lang=js"
export * from "./SelectDefault.vue?vue&type=script&lang=js"
import style0 from "./SelectDefault.vue?vue&type=style&index=0&id=b5d425a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d425a0",
  null
  
)

export default component.exports